/* commissionAccrualCheck.js -- STEP 9's COMMISSION ROW (commission ship 5, 2026-10-10).
 *
 * Two questions, each answered by its ONE owner -- nothing is re-spelled here:
 *   1. is the answer MISSING?            utils/commissionAccrualDisplay.js commissionAnswerMissing (the Step-5 gate's own rule:
 *                                         a commissioned rep and no stored answer). Step 9 asks it again because the wizard's
 *                                         step bar can open Step 6+ once Step 5 is complete, past Step 5's continue.
 *   2. what does P23 say about it?       engines/preflightCheck.js -- the REAL pre-flight, run on the balance-sheet lines the
 *                                         model builds (engines/buildBSLines.js, the same 6th / 7th arguments ModelProvider passes);
 *                                         only P23's own finding is read, in P23's own words (its register entry + each offender).
 * Silent for a company that does not accrue commissions (P23 is). Plain ASCII on purpose (CLAUDE.md 12.5 rule 55). */
import { accruesCommissions, commissionAccrualFromSettings } from '../engines/commissionAccrual';
import { payScheduleFromSettings } from '../engines/paySchedule';
import { buildBSLinesForCompany } from '../engines/buildBSLines';
import { describeCheck, preflightCheck } from '../engines/preflightCheck';
import { commissionAnswerMissing } from './commissionAccrualDisplay';

/* `settings` = the settings GET row; `employees` = the employees GET rows; `bsActualsMeta` = the balance-sheet meta with each
   label from its owner (overlayLeafLabels); `bsAssumptions` = the bs-assumptions GET object (keyed by line id).
   Returns { missing: string|null, p23: null | { name, meaning, fix, offenders: [{ arm, what }] } }. */
export function commissionAccrualProblems({ companyId, settings, employees, bsActualsMeta, bsAssumptions }) {
  const s = settings || {};
  const missing = commissionAnswerMissing(employees, s);
  const accrual = commissionAccrualFromSettings(s);
  if (missing || !accruesCommissions(accrual)) return { missing, p23: null };
  const meta = bsActualsMeta || {};
  const payrollKey = s.accrued_payroll_bs_line_key || null;
  const bsLines = buildBSLinesForCompany(companyId, meta, [], {}, [], { schedule: payScheduleFromSettings(s), lineKey: payrollKey }, accrual);
  const pf = preflightCheck({
    bsLines, bsAssumptions: bsAssumptions || {}, bsActualsMeta: meta, accruedPayrollLineKey: payrollKey,
    commissionAccrual: accrual,
    commissionReps: (employees || []).filter(e => e && (e.is_sales_rep === true || e.is_sales_rep === 'true'))
      .map(e => ({ id: e.id, name: e.name, commission_frequency: e.commission_frequency || null })),
  });
  const f = (pf.failures || []).find(x => x.id === 'P23' && x.severity === 'BLOCKING');
  if (!f) return { missing: null, p23: null };
  const d = describeCheck('P23', f.severity);
  return { missing: null, p23: { name: d.name, meaning: d.meaning, fix: d.fix, offenders: f.offenders.map(o => ({ arm: o.arm, what: o.what })) } };
}
